import { render, staticRenderFns } from "./BuildingsGuidelines.vue?vue&type=template&id=3d6a9154&scoped=true"
import script from "./BuildingsGuidelines.vue?vue&type=script&lang=js"
export * from "./BuildingsGuidelines.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6a9154",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/disk1/buildAgent/work/ffa2b6072150c7f8/vAnalyticsJS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d6a9154')) {
      api.createRecord('3d6a9154', component.options)
    } else {
      api.reload('3d6a9154', component.options)
    }
    module.hot.accept("./BuildingsGuidelines.vue?vue&type=template&id=3d6a9154&scoped=true", function () {
      api.rerender('3d6a9154', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/modules/admin/components/BuildingsSpaces/BuildingsGuidelines.vue"
export default component.exports